<ng-container *notInPopulation="populations.TicketTransfer">
  <ng-container *ifScreenSize="screenType.Desktop">
    <div class="banner" role="banner">
      <h1>{{ 'home.page.title' | translate }} {{ name$ | async }}</h1>
    </div>
  </ng-container>

  <ng-container *ifScreenSize="screenType.Mobile">
    <fgb-barcode></fgb-barcode>
  </ng-container>

  <div class="container">
    <!-- Cards -->
    <ng-container *ifScreenSize="screenType.Desktop">
      <div class="row mt-4">
        <div class="col-lg-6">
          <fgb-member-card></fgb-member-card>
        </div>

        <ng-container *notInPopulation="populations.U18">
          <div class="col-lg-6 cursor-pointer" [routerLink]="['/earn']">
            <div class="widget rounded">
              <h4 class="mb-0 text-white">EARN MORE</h4>
              <h4 class="mb-0 text-white">UNLOCK MORE</h4>
              <h4 class="mb-0 text-white">WIN MORE</h4>
            </div>
          </div>
        </ng-container>

        <ng-container *inPopulation="populations.U18">
          <div class="col-lg-6 cursor-pointer" [routerLink]="['/games']">
            <div class="widget game-widget rounded">
              <h4 class="mb-0 text-white">GAMES</h4>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <div class="mt-3 container pe-lg-0">
    <fgb-vouchers></fgb-vouchers>
  </div>

  <!--Scorecard carousel-->
  <div class="mt-4">
    <fgbcl-scorecard-carousel [link]="'badges'" [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>

    <ng-container *ngIf="scorecard$ | async as activeScorecards">
      <a *ngIf="activeScorecards.length > 0" class="w-100 d-flex justify-content-center" [routerLink]="'/challenges'">
        <div class="view-all-btn">{{ 'home.view.all.button' | translate }}</div>
      </a>
    </ng-container>
  </div>

  <div class="container">
    <ng-container *notInPopulation="populations.U18">
      <fgbcl-featured-rewards></fgbcl-featured-rewards>

      <ng-container *ngIf="mixedLoyaltyItems$ | async as mixedLoyaltyItems">
        <a
          *ngIf="mixedLoyaltyItems.length"
          class="w-100 d-flex justify-content-center mt-3"
          [routerLink]="'/rewards/marketplace'"
        >
          <div class="view-all-btn">{{ 'home.view.all.button' | translate }}</div>
        </a>
      </ng-container>
    </ng-container>

    <!-- Announcements -->
    <fgbcl-announcements></fgbcl-announcements>
  </div>
</ng-container>

<ng-container *inPopulation="populations.TicketTransfer">
  <fgb-ticket-transfer-page></fgb-ticket-transfer-page>
</ng-container>
